import type { PulseReportKind } from '../types/pulseReport'

const endpoint = import.meta.env.VITE_PULSE_REPORT_ANALYTICS_URL as string | undefined

export type PulseReportTelemetryEvent =
  | { name: 'pulse_report_started'; props: { workspaceId: string; kind: PulseReportKind; source: 'button' | 'auto' } }
  | { name: 'pulse_report_completed'; props: { reportId: string; kind: PulseReportKind; cached: boolean; creditsCharged: number; durationMs: number } }
  | { name: 'pulse_report_failed'; props: { kind: PulseReportKind; code?: string | null; message: string } }
  | { name: 'ai_history_opened'; props: { sessionId: string; kind: string; source: 'row' | 'preview_sheet' } }
  | { name: 'ai_history_preview_opened'; props: { sessionId: string; kind: string; source: 'long_press' } }
  | { name: 'ai_agent_mode_toggled'; props: { from: 'CREATE' | 'EXECUTE'; to: 'CREATE' | 'EXECUTE' } }

export const trackPulseReportEvent = <E extends PulseReportTelemetryEvent>(event: E): void => {
  const payload = { ...event, ts: Date.now() }
  if (endpoint) {
    void fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch((error) => console.debug('[pulse-report-analytics] endpoint failure', error))
    return
  }
  if (typeof console !== 'undefined' && typeof console.debug === 'function') {
    console.debug('[pulse-report-analytics]', payload)
  }
}
